module.exports = __webpack_public_path__ + "img/surdej.d782e1b0.jpg";